const NAVBAR_HEIGHT = "60px";

export { NAVBAR_HEIGHT };
